import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-store-03',
  standalone: true,
  templateUrl: '../../assets/store-03.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamStore03Icon {}
